import React from 'react';
import styled from 'styled-components';

import { mainContainer } from '../../containers/mainContainer';

import projects from '../../tools/projects';
import ReactModal from '../modal';

const ProjectContainer = styled.div`
  height: 100%;
  width: 100%;
`;
const ProjectsHeader = styled.h2`
  margin-left: 1rem;
  color: #ed5a5c;
`;
const ProjectsShowcase = styled.div`
  display: block;
  height: 80%;
  overflow: auto;
`;
const ProjectTile = styled.div`
  width: 44%;
  min-height: 240px;
  margin: 10px 8px;
  padding: 0px 16px;
  border-radius: 6px;
  border: 1px solid #b381f2;
  float: left;
  text-align: center;
  background-color: #eaeaea;
  :hover {
    cursor: pointer;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.75);
  }
`;
const ProjectTitle = styled.h2`
  color: #5b5f97;
  margin: 10px auto;
`;
const ProjectOneliner = styled.p`
  color: #087e8b;
`;
const BubbleWrapper = styled.div`
  margin: 1rem 0px;
`;
const Bubble = styled.div`
  background-color: #0c7489;
  display: inline-block;
  color: #fff;
  margin: 5px 10px;
  padding: 5px 8px;
  height: 24px;
  border-radius: 8px;
`;

const openProjectDetails = project => {
  mainContainer.setState({ isModalOpen: true, projectDetail: project });
};
const displayTechsUsed = tech => {
  return tech.map(data => <Bubble key={data}>{data}</Bubble>);
};
const displayProjects = () => {
  return projects.map(project => {
    return (
      <ProjectTile
        key={project.key}
        onClick={() => openProjectDetails(project)}
      >
        <ProjectTitle>{project.name}</ProjectTitle>
        <ProjectOneliner>{project.oneliner}</ProjectOneliner>
        <BubbleWrapper>{displayTechsUsed(project.tech)}</BubbleWrapper>
      </ProjectTile>
    );
  });
};

const Projects = props => {
  return (
    <ProjectContainer>
      <ProjectsHeader>Projects</ProjectsHeader>
      <ProjectsShowcase>{displayProjects()}</ProjectsShowcase>
      <ReactModal />
    </ProjectContainer>
  );
};

export default Projects;
